import type { FindOperationsInput } from '@travel-planner/shared/schemas/operations';
import { trpc } from '@/shared/api/trpc';

export const useFlaggedItemsData = (
  input: FindOperationsInput,
  options?: { enabled?: boolean }
) =>
  trpc.operations.flaggedItems.useQuery(input, {
    enabled: options?.enabled ?? true,
  });
